module.exports = __webpack_public_path__ + "img/popover-bg.969d2a7.png";